import { useEffect, useState } from 'react'
import Select from 'react-tailwindcss-select'
import useMinerals from '../../hooks/useMinerals'

export default function SelectMultiMinerals({ defaultValue, onChange }) {
  const { minerals, isLoading } = useMinerals()
  const [selectedMinerals, setSelectedMinerals] = useState(defaultValue ?? null)

  useEffect(() => {
    if (defaultValue?.length && minerals?.length) {
      const selected = minerals
        .filter((mineral) => defaultValue.includes(mineral.id))
        .map((mineral) => ({
          value: mineral.id,
          label: mineral.name_ar,
          name_en: mineral.name_en,
          image: mineral.image,
        }))
      setSelectedMinerals(selected)
    }
  }, [defaultValue, minerals])

  const handleOnChange = (options) => {
    setSelectedMinerals(options)
    onChange(options)
  }

  return (
    <Select
      value={selectedMinerals}
      onChange={handleOnChange}
      loading={isLoading}
      isMultiple
      isSearchable
      searchInputPlaceholder="الخامات ..."
      options={minerals?.map((mineral) => ({
        value: mineral.id,
        label: mineral.name_ar,
        name_en: mineral.name_en,
        image: mineral.image,
      }))}
      placeholder="الخامات ..."
      classNames={{
        menuButton: ({ isDisabled }) =>
          `focus:outline-none border-2 border-muted-500 py-0.5 flex bg-white pr-2`,
        tagItem: ({ item, isDisabled }) =>
          `flex justify-between min-w-[120px] items-center`,
        tagItemText:
          'p-1 bg-muted-300 border-2 border-l-0 border-muted-600 pr-1.5 w-full',
        tagItemIconContainer:
          'p-1 px-[6px] hover:bg-danger-500 border-2 h-full hover:text-white text-danger-600 bg-danger-300 border-danger-500',
        searchContainer: 'relative w-full',
        searchIcon: 'absolute left-3 top-[9px] text-primary-200  w-6  h-6',
        searchBox: 'w-full outline-none border-b-2 border-muted p-3',
        menu: `absolute z-50 -mt-1 w-full shadow-lg bg-white border-2 border-muted-500 pb-2 `,
      }}
      formatOptionLabel={(data) => (
        <li
          className={`z-50 line-clamp-1 block cursor-pointer select-none px-4 py-3 ${data.isSelected ? `bg-accent-600 text-white` : `hover:bg-accent-600 hover:text-white`}`}
        >
          <div className="flex items-center gap-2">
            <img
              className="h-8 w-8"
              src={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${data.image}`}
              alt={data.label}
            />
            <div>{data.label}</div>
          </div>
        </li>
      )}
    />
  )
}
